import { createContext, PropsWithChildren, useContext } from 'react';

interface AssetContextProps {
  basePublicFilesUrl: string;
  getAssetUrl: (paths: string[]) => string;
}

const AssetContext = createContext<AssetContextProps | undefined>(undefined);

export const AssetProvider: React.FC<
  PropsWithChildren<{ basePublicFilesUrl: string }>
> = ({ children, basePublicFilesUrl }) => {
  const getAssetUrl = (paths: string[]): string =>
    [basePublicFilesUrl, ...paths].join('/');

  return (
    <AssetContext.Provider value={{ basePublicFilesUrl, getAssetUrl }}>
      {children}
    </AssetContext.Provider>
  );
};

export const useAssetContext = (): AssetContextProps => {
  const context = useContext(AssetContext);
  if (!context) {
    throw new Error('useAssetContext must be used within an AssetProvider');
  }
  return context;
};
